import { render, staticRenderFns } from "./addCustomer.vue?vue&type=template&id=3a786a84&scoped=true"
import script from "./addCustomer.vue?vue&type=script&lang=js"
export * from "./addCustomer.vue?vue&type=script&lang=js"
import style0 from "./addCustomer.vue?vue&type=style&index=0&id=3a786a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a786a84",
  null
  
)

export default component.exports